import React from 'react';

/**
 * SiliconeToggle - Translucent silicone button (Style 1)
 * Frosted silicone with light bleeding through from behind.
 * Used for overlay layer toggles (Score, Form, Logo).
 */
export const SiliconeToggle = ({ children, color = 'blue', active, onClick }) => {
  const colors = {
    blue: {
      base: 'from-blue-400/20 to-blue-600/40',
      border: 'border-blue-400/50',
      shadow: 'shadow-[0_0_20px_rgba(59,130,246,0.4),inset_0_2px_4px_rgba(255,255,255,0.2),inset_0_-2px_8px_rgba(59,130,246,0.3)]',
      hoverShadow: 'hover:shadow-[0_0_30px_rgba(59,130,246,0.6),inset_0_2px_4px_rgba(255,255,255,0.3),inset_0_-2px_12px_rgba(59,130,246,0.5)]',
      activeBase: 'from-blue-400/50 to-blue-600/70',
      activeBorder: 'border-blue-300/80',
      activeShadow: 'shadow-[0_0_35px_rgba(59,130,246,0.8),inset_0_2px_4px_rgba(255,255,255,0.3),inset_0_-2px_12px_rgba(59,130,246,0.6)]',
    },
    green: {
      base: 'from-green-400/20 to-green-600/40',
      border: 'border-green-400/50',
      shadow: 'shadow-[0_0_20px_rgba(34,197,94,0.4),inset_0_2px_4px_rgba(255,255,255,0.2),inset_0_-2px_8px_rgba(34,197,94,0.3)]',
      hoverShadow: 'hover:shadow-[0_0_30px_rgba(34,197,94,0.6),inset_0_2px_4px_rgba(255,255,255,0.3),inset_0_-2px_12px_rgba(34,197,94,0.5)]',
      activeBase: 'from-green-400/50 to-green-600/70',
      activeBorder: 'border-green-300/80',
      activeShadow: 'shadow-[0_0_35px_rgba(34,197,94,0.8),inset_0_2px_4px_rgba(255,255,255,0.3),inset_0_-2px_12px_rgba(34,197,94,0.6)]',
    },
  };

  const c = colors[color] || colors.blue;

  const baseClasses = active
    ? `bg-gradient-to-b ${c.activeBase} ${c.activeBorder} ${c.activeShadow}`
    : `bg-gradient-to-b ${c.base} ${c.border} ${c.shadow} ${c.hoverShadow}`;

  return (
    <button
      onClick={onClick}
      className={`
        relative px-3 py-1.5 rounded backdrop-blur-sm border-2
        transition-all active:translate-y-0.5
        ${baseClasses}
      `}
    >
      <span className="text-white font-bold text-xs drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)] uppercase tracking-wide">
        {children}
      </span>
    </button>
  );
};
